import { type LaunchDarklyContext } from '../launch-darkly.types';
import {
  withGeneratedContextKey,
  withGeneratedContextKeyByHash,
} from './with-generated-context-key';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Formats the context object to be used by the LaunchDarkly client to add
 * the required key property.
 */
export async function formatContextEntry([contextKind, context]: [string, LaunchDarklyContext]) {
  const formattedContext = await formatContext(context);

  return [contextKind, formattedContext];
}

// ─────────────────────────────────────────────────────────────────────────────

async function formatContext(context: LaunchDarklyContext) {
  /**
   * If true, the key will be generated by hashing the context object.
   *
   * This is useful to avoid re-identifying the context and be consistent
   * across app restarts.
   */
  const shouldGenerateKeyByHash = !context.key && !context.anonymous;

  if (shouldGenerateKeyByHash) {
    return {
      ...(await withGeneratedContextKeyByHash(context)),
      ...context,
    };
  }

  return {
    // NOTE: If key is not provided, LD client will generate
    //       a device-unique string automatically.
    ...withGeneratedContextKey(),
    ...context,
  };
}
